import React from 'react'
import "./First.css"
import myImage from '../../images/jupor1.webp'
import Navbar from '../../navbar/Navbar'
function First() {
  return (
    <div>
      <div className='first'>
          <section className='hero container'>
            <Navbar/>
            <div  className='container fc1' >
              <h1 className='fc2'>Your Beginning</h1>
              <h1 className='fc2'>Our Responsibility</h1>

              <h4 className='fc3'>Guiding Your Next Step!</h4>
              <div className='container'>
                <button className='button'><p id="issa" className='btn-txt'>Start your study abroad journey</p></button>        
              </div>
            </div>
          </section>
      </div>
    </div>
  )
}

export default First
